(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["horizontal-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecg-collection-slider')) {
    customElements.define('ecg-collection-slider', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.track = this.querySelector('[data-ecg-track]');
        this.controls = this.querySelector('[data-ecg-controls]');
        this.previous = this.querySelector('[data-ecg-prev]');
        this.next = this.querySelector('[data-ecg-next]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.desktop = matchMedia('(min-width: 990px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => this.updateControls();

        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.desktop.addEventListener('change', update, { signal });
        window.addEventListener('resize', update, { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          if (!this.desktop.matches) return;
          const column = event.target.closest('.editorial-collection-grid__column');
          if (!column || column.parentElement !== this.track) return;
          const viewport = this.track.getBoundingClientRect();
          const card = column.getBoundingClientRect();
          const offset = card.left < viewport.left ? card.left - viewport.left
            : card.right > viewport.right ? card.right - viewport.right : 0;
          if (offset) this.track.scrollBy({ left: offset, behavior: 'instant' });
        }, { signal });

        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        for (const column of this.track.children) this.observer.observe(column);
        update();
      }

      updateControls() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const overflowing = this.desktop.matches && maximum > 2;
        this.controls.hidden = !overflowing;
        if (overflowing) {
          this.track.tabIndex = 0;
          this.track.setAttribute('role', 'region');
        } else {
          this.track.removeAttribute('tabindex');
          this.track.removeAttribute('role');
        }
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = !overflowing || position <= 2;
        this.next.disabled = !overflowing || position >= maximum - 2;
      }

      move(direction) {
        const column = this.track.firstElementChild;
        if (!column || !this.desktop.matches) return;
        const styles = getComputedStyle(this.track);
        const step = column.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
        const sign = styles.direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: direction * step * sign,
          behavior: this.reducedMotion.matches ? 'instant' : 'smooth'
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
